export default __webpack_public_path__ + "static/media/detail_mobile_9_3.053a3ed1.jpg";